/* pantallas-alumno (B): LA CASILLA (piezas nuevas de la parte 1).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   22 px, radio 7, borde de 1.5 px #3A3A3A sobre #0E0E0E; marcada: fondo #F27A2E con palomita #160A02.
   Es SOLO el dibujo (escondido del lector de pantalla): el area tactil es todo el renglon, que es
   quien lleva `role="checkbox"` y `aria-checked` (ver RenglonDeDocumento). */
import React from 'react';
import { Check } from 'lucide-react';

export default function Casilla({ marcada = false, testid, className = '' }) {
  return (
    <span
      aria-hidden="true"
      data-testid={testid}
      data-marcada={marcada ? 'true' : 'false'}
      className={`w-[22px] h-[22px] shrink-0 rounded-[7px] border-[1.5px] flex items-center justify-center ${marcada ? 'bg-[#F27A2E] border-[#F27A2E]' : 'bg-[#0E0E0E] border-[#3A3A3A]'} ${className}`.trim()}
    >
      {marcada ? <Check className="w-3.5 h-3.5 text-[#160A02]" strokeWidth={3} /> : null}
    </span>
  );
}
